
import React, { useEffect, useState } from 'react'

import { useStyles } from './staged-flow-controls.style'

export const StagedFlowControls = function ({ demographics, demographicColors, onSelect }) {
  const classes = useStyles()
  const [demographicOptions, setDemographicOptions] = useState([])
  const [selectedDemographicOption, setSelectedDemographicOption] = useState('-1')
  const [selectedDemographicValues, setSelectedDemographicValues] = useState([])
  const [selectedDemographicColors, setSelectedDemographicColors] = useState([])

  useEffect(() => {
    if (!demographics) {
      return
    }

    const options = [{ value: -1, label: 'None' }]

    demographics[0].forEach((thisDemographic, index) => {
      options.push({ value: index, label: thisDemographic })
    })

    setDemographicOptions(options)
    setSelectedDemographicOption('-1')
    setSelectedDemographicValues([])
    setSelectedDemographicColors([])
  }, [demographics])

  function selectDemographicCategory (event) {
    const selectedDemOption = event.target.value
    const selectedDemCategory = parseInt(selectedDemOption, 10)

    setSelectedDemographicOption(selectedDemOption)
    setSelectedDemographicValues(selectedDemCategory < 0 ? [] : demographics[selectedDemCategory + 1])
    setSelectedDemographicColors(selectedDemCategory < 0 ? [] : demographicColors[selectedDemOption])
    onSelect(selectedDemCategory)
  }

  if (demographicOptions.length <= 1) {
    return null
  }

  return (
    <div className={classes.topControls} data-qa="staged-flow-controls">
      <label className={classes.topControlsLabel}>Segment by</label>
      <select className={classes.topControlsSelect} value={selectedDemographicOption} onChange={selectDemographicCategory}>
        {demographicOptions.map((option) =>
          <option key={option.value} value={option.value}>{option.label}</option>
        )}
      </select>
      <div className={classes.legendPane}>
        {selectedDemographicValues.map((label, index) =>
          <div key={label} className={classes.legendCell}>
            <div className={classes.legendBand} style={{ backgroundColor: selectedDemographicColors[index] }} />
            <div className={classes.legendLabel}>
              {label}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
